import { useFormikContext } from 'formik';
import {
  IContractTemplateForm,
  SIDE_MENU_TYPE,
} from 'services/templates/types';
import ContractAgreementDetails from './agreement-detail/ContractAgreementDetails';
import ContractTemplatesLists from './templates-list/ContractTemplatesLists';

const ContractSideMenu = () => {
  const { values } = useFormikContext<IContractTemplateForm>();

  if (!values.sideMenu) {
    return null;
  }

  const type = values.sideMenu.type;

  if (type === SIDE_MENU_TYPE.agreementDetail) {
    return <ContractAgreementDetails />;
  }

  if (type === SIDE_MENU_TYPE.customTemplatesList) {
    return <ContractTemplatesLists />;
  }

  return null;
};

export default ContractSideMenu;
